var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.5 18.592-6.06-6.06 2.122-2.122L9.5 14.35l8.939-8.94 2.122 2.122L9.5 18.592Z",
    fill: "#4D4D4D"
  })));
};
export { SvgTick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjUwMDk0IDE4LjU5MjJMMy40Mzk5NCAxMi41MzIyTDUuNTYxOTQgMTAuNDEwMkw5LjUwMDk0IDE0LjM1MDJMMTguNDM5OSA1LjQxMDE2TDIwLjU2MTkgNy41MzIxNkw5LjUwMDk0IDE4LjU5MjJaIiBmaWxsPSIjNEQ0RDREIi8+Cjwvc3ZnPgo=";